import {Base} from "@/api/Base"

export class ReportBatchConfirm extends Base {
    path = "report/batchConfirm"
}